import api from '../../helpers/api';

export const getSupplierCategories = (body) => api.post('job-category/search' , {...body})

export const createSupplierCategory = (formData) => api.post('job-category' , {...formData})

export const updateSupplierCategory = (id , formData) => api.put(`job-category/${id}`, {...formData} )

export const getParentCategories = (body) => api.post(`supplier-category/category-tree`, {...body})